module.exports = __webpack_public_path__ + "img/seven.c397480f.png";